(() => {
 const body = document.body;
 if (!body.classList.contains('nov-business')) return;
 const params = new URLSearchParams(location.search);
 const theme = window.Shopify && window.Shopify.theme;
 const draft = params.get('preview_theme_id') || (theme && theme.role === 'unpublished' ? String(theme.id) : '');
 const route = (view, extra = {}, hash = '') => window.NOVJourney.route(view, extra, hash);
 const legacy = {
  '/pages/schools-tuckshops':'nov-schools-tuckshops', '/pages/catering-hub':'nov-catering-events',
  '/pages/hospitality-corporate':'nov-hospitality-corporate', '/pages/school-ordering-hub':'nov-school-ordering-hub',
  '/pages/wholesale-account':'nov-wholesale-account', '/pages/wholesale-quick-order':'nov-wholesale-quick-order',
  '/pages/school-quick-order':'nov-school-quick-order', '/pages/portion-cost-calculator':'nov-school-calculator',
  '/pages/recipes-menu-ideas':'nov-school-recipes', '/collections/schools-tuckshops':'nov-school-catalogue',
  '/pages/public-portion-cost-calculator':'nov-wholesale-calculator', '/pages/recipes-serving-ideas':'nov-public-recipes'
 };
 const oldViews = {'tcp-business':'nov-business-supply','tcp-supply':'nov-business-supply','tcp-wholesale':'nov-wholesale-supply','tcp-school':'nov-schools-tuckshops','tcp-catering':'nov-catering-events','tcp-corporate':'nov-hospitality-corporate','tcp-trade':'nov-business-supply','tcp-range':'nov-wholesale-catalogue'};
 const rewrite = link => {
  const raw = link.getAttribute('href');
  if (!raw || raw.startsWith('#')) return;
  const url = new URL(raw, location.origin);
  if (url.origin !== location.origin) return;
  if (url.pathname === '/customer_authentication/login') {
   const target = url.searchParams.get('return_to');
   if (target) { const destination = new URL(target, location.origin); if (legacy[destination.pathname]) url.searchParams.set('return_to', route(legacy[destination.pathname])); }
   link.href = url.pathname + url.search;
   return;
  }
  let view = legacy[url.pathname] || oldViews[url.searchParams.get('view')];
  if (url.pathname === '/pages/contact' && url.searchParams.get('view') === 'tcp-apply') {
   const kind = url.searchParams.get('business');
   view = ['wholesale','school','catering','corporate','hospitality'].includes(kind) ? 'nov-' + (kind === 'corporate' ? 'hospitality' : kind) + '-application' : 'nov-business-login';
  }
  if (link.closest('.nov-legacy-recipes') && url.pathname.startsWith('/products/')) {
   link.href = route('nov-school-catalogue', {}, url.pathname.split('/').pop()); return;
  }
  if (view) link.href = route(view, {product:url.searchParams.get('product'),q:url.searchParams.get('q')}, url.searchParams.get('view')==='tcp-trade' ? 'profiles' : url.hash);
  else if (draft && /^\/(pages|policies|cart|search|$)/.test(url.pathname)) {url.searchParams.set('preview_theme_id', draft);link.href=url.pathname+url.search+url.hash;}
 };
 body.querySelectorAll('a[href]').forEach(rewrite);
 body.addEventListener('click', event => {const link=event.target.closest('a[href]'); if(link) rewrite(link);}, true);
 const search = body.querySelector('.nov-search');
 if (search) {
  const view = search.querySelector('[name="view"]');
  if (view) view.value = body.querySelector('[data-nov-view="school-catalogue"]') ? 'nov-school-catalogue' : 'nov-wholesale-catalogue';
 }
 const catalogue = body.querySelector('[data-nj-catalogue]');
 if (catalogue) {
  const field = catalogue.querySelector('[data-nj-search]'), type = catalogue.querySelector('[data-nj-type]');
  const cards = [...catalogue.querySelectorAll('[data-nj-product]')];
  const status = catalogue.querySelector('[data-nj-count]'), more = catalogue.querySelector('[data-ns-more]');
  const chickenGroup = 'group:chicken';
  const chickenTypes = new Set(['Chicken Fillers', 'Chicken Tenders', 'Chicken Wedges', 'Chicken Wings', 'Cooked Chicken', 'Fresh Chicken', 'Prepared Chicken']);
  const batch = () => matchMedia('(max-width: 640px)').matches ? 6 : 12;
  let limit = batch();
  const filter = (reset = true) => {
   if (reset) limit = batch();
   const query = field.value.trim().toLocaleLowerCase();
   const matches = cards.filter(card => {
    const matchesType = type.value === chickenGroup
      ? chickenTypes.has(card.dataset.type)
      : !type.value || card.dataset.type === type.value;
    return matchesType && (!query || card.dataset.search.includes(query));
   });
   cards.forEach(card => card.hidden = true);
   matches.slice(0, limit).forEach(card => card.hidden = false);
   status.textContent = status.dataset.countLabel.replace('__SHOWN__', Math.min(limit,matches.length)).replace('__TOTAL__',matches.length);
   catalogue.querySelector('[data-nj-empty]').hidden = matches.length > 0;
   more.hidden = matches.length <= limit;
   catalogue.querySelectorAll('[data-ns-type]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.nsType===type.value)));
   body.querySelectorAll('[data-nc-type]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.ncType===type.value)));
   const resultTitle=catalogue.querySelector('[data-bs-result-title]');
   if(resultTitle)resultTitle.textContent=type.value ? type.selectedOptions[0].textContent : (query ? resultTitle.dataset.searchLabel : resultTitle.dataset.allLabel);

  };
  field.value = params.get('q') || '';
  const categoryHashes = { kebabs: 'Kebabs', 'burgers-patties': 'Burgers & Patties', schnitzels: 'Schnitzels', 'food-service': chickenGroup };
  const requestedType = categoryHashes[location.hash.slice(1)] || (params.get('group') === 'chicken' ? chickenGroup : params.get('type'));
  if ([...type.options].some(option => option.value === requestedType)) type.value = requestedType;
  field.addEventListener('input',()=>filter());type.addEventListener('change',()=>filter());
  catalogue.querySelector('form').addEventListener('submit',event=>{event.preventDefault();filter();});
  catalogue.querySelector('[data-nj-clear]').addEventListener('click',()=>{field.value='';type.value='';filter();field.focus();});
  catalogue.querySelectorAll('[data-ns-type]').forEach(button=>button.addEventListener('click',()=>{type.value=button.dataset.nsType;filter();}));
  body.querySelectorAll('[data-nc-type]').forEach(button=>button.addEventListener('click',()=>{const selected=button.dataset.ncType;if(![...type.options].some(option=>option.value===selected))return;field.value='';type.value=selected;filter();catalogue.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});type.focus({preventScroll:true});}));
  more.addEventListener('click',()=>{const previous=limit;limit+=batch();filter(false);const visible=cards.filter(card=>!card.hidden);visible[previous]?.querySelector('button')?.focus({preventScroll:true});});
  const target=cards.find(card=>card.dataset.handle===decodeURIComponent(location.hash.slice(1)));
  if(target){field.value=target.querySelector('h3').textContent.trim();type.value='';}
  matchMedia('(max-width: 640px)').addEventListener('change',()=>filter());
  filter();
 }
 const profileButtons = [...body.querySelectorAll('[data-nj-profile]')];
 if (profileButtons.length) {
  const setProfile = profile => {
   if (!profileButtons.some(button=>button.dataset.njProfile===profile)) profile='wholesale';
   profileButtons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.njProfile===profile)));
   body.querySelectorAll('[data-nj-recommend]').forEach(group=>group.hidden=group.dataset.njRecommend!==profile);body.dataset.nsProfile=profile;body.dispatchEvent(new CustomEvent('ns:profile',{detail:profile}));
  };
  profileButtons.forEach(button=>button.addEventListener('click',()=>{setProfile(button.dataset.njProfile);history.replaceState(null,'',location.pathname+location.search+'#'+button.dataset.njProfile);}));
  setProfile(location.hash.slice(1));
 }
 const requirements = body.querySelector('#nj-requirements');
 if (requirements && !requirements.value.trim() && params.get('product')) requirements.value = params.get('product').slice(0,250);
 const nativeSearch = body.querySelector('.tcp-quick-order__search');
 if (nativeSearch && params.get('q')) { nativeSearch.value=params.get('q');nativeSearch.dispatchEvent(new Event('input',{bubbles:true})); }
 let printWasOpen = false;
 window.addEventListener('beforeprint', () => {const details=body.querySelector('.nj-nutrition');if(details){printWasOpen=details.open;details.open=true;}});
 window.addEventListener('afterprint', () => {const details=body.querySelector('.nj-nutrition');if(details)details.open=printWasOpen;});
})();


